import React from "react";
import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/core/styles";
import { l } from "../functions";

const MySlider = withStyles({
  valueLabel: {
    "& *": {
      background: "#FFF",
      color: "#000",
    },
  },
})(Slider);

export default class SliderRange extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
      textValue: this.props.value,
      error: this.props.error || false,
    };
  }

  componentWillReceiveProps({ value }) {
    if (value !== this.props.value && value !== this.state.value)
      this.setState({ value: value, textValue: value });
  }

  render() {
    const { min, max, onChange } = this.props;

    const { value } = this.state;

    return (
      <div
        className={`gk-form-row-container slider-range ${
          !Array.isArray(value) ? "mright" : ""
        }`}
        style={this.props?.style}
      >
        <MySlider
          aria-labelledby={
            Array.isArray(value) ? "range-slider" : "discrete-slider"
          }
          valueLabelDisplay="auto"
          value={value}
          min={min}
          max={max}
          onChange={(event, value) => {
            this.setState({ value: value, textValue: value, error: false });
          }}
          onChangeCommitted={(event, value) => {
            onChange(value);
          }}
        />
        {!Array.isArray(value) && (
          <div className="tooltip-container">
            {this.state.error && (
              <span className="my-tooltip top-left">{l("Invalid!")}</span>
            )}
            <input
              type="text"
              value={this.state.textValue}
              onChange={(event) => {
                const val = event.target.value;
                const format = /[1234567890]/;

                this.setState(
                  {
                    textValue: val,
                  },
                  () => {
                    if (
                      format.test(val) &&
                      parseInt(val) >= min &&
                      parseInt(val) <= max
                    ) {
                      this.setState(
                        {
                          value: parseInt(val),
                          error: false,
                        },
                        () => {
                          onChange(parseInt(val));
                        }
                      );
                    } else {
                      this.setState({ error: true });
                    }
                  }
                );
              }}
            />
          </div>
        )}
      </div>
    );
  }
}
